import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/Hero/Hero";
import GridBox from "../../components/Home/GridBox/GridBox";
import Footer from "../../components/Footer/Footer";

import img1 from "../../assets/images/homepage-general.jpg";
import acra from "../../assets/images/acra.png";
import fieldImgThree from "../../assets/images/field-img-3.jpg";
import fieldImgFiftySeven from "../../assets/images/field-img-57.jpg";
import fieldImgTwo from "../../assets/images/field-img-2.jpg";
import fieldImgSeven from "../../assets/images/field-img-7.jpg";
import nswTradingLicense from "../../assets/images/nsw-fair-trading.svg";
import masterBuilder from "../../assets/images/master-builders-member.png";
import memberEngineersAustralia from "../../assets/images/engineers-australia.png";

import classes from "./Home.module.scss";

const credentials = [
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading building licence",
    text: "Building Licence 278427C",
  },
  {
    image: memberEngineersAustralia,
    alt: "Engineers Australia member",
    text: "Engineers Australia Member ID: 5064521",
  },
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading body corporate registration",
    text: "Body Corporate Registration BUP0003949",
  },
  {
    image: masterBuilder,
    alt: "Master Builders Association member",
    text: "Master Builders Member ID: 3508168",
  },
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading building practitioner",
    text: "Building Practitioner BUP0001885",
  },
  {
    image: acra,
    alt: "ACRA member",
    text: "ACRA Membership Number: 559",
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.home}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Unified Building Group | Remediate, Restore, Revitalise</title>
        <meta
          name="description"
          content="Unified Building Group provides remedial building, restoration and construction services across NSW, backed by over 30 years of combined experience."
        />
      </Helmet>

      <Navbar />

      <Hero
        image={fieldImgThree}
        title="Unified Building Group"
        slogan="Remediate, Restore, Revitalise"
      />

      <main>
        <section className={classes.introSection}>
          <div className={classes.container}>
            <div className={classes.introContent}>
              <p className={classes.eyebrow}>Experienced remedial builders</p>
              <h1>Over 30 years of combined building experience</h1>
              <p>
                Unified Building Group Pty Limited is an Australian privately
                owned company operating in NSW, supported by qualified project
                managers and experienced tradespeople.
              </p>
              <p>
                Our multi-skilled team provides professional diagnosis of
                building issues and delivers honest, practical and long-term
                solutions for owners, strata clients and property stakeholders.
              </p>

              <button
                className={classes.btn}
                onClick={() => navigate("/about")}
              >
                About Us
              </button>
            </div>

            <div className={classes.introImage}>
              <img src={img1} alt="Unified Building Group construction work" />
            </div>
          </div>
        </section>

        <section className={classes.credentialsSection}>
          <div className={classes.container}>
            <div className={classes.sectionHeader}>
              <p className={classes.eyebrow}>Licences & memberships</p>
              <h2>Qualified, registered and trusted</h2>
            </div>

            <div className={classes.credentialsGrid}>
              {credentials.map((item) => (
                <div className={classes.credentialCard} key={item.text}>
                  <img src={item.image} alt={item.alt} />
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={classes.whySection}>
          <div className={classes.container}>
            <div className={classes.sectionHeader}>
              <p className={classes.eyebrow}>Why choose us</p>
              <h2>Why Unified Building Group?</h2>
            </div>

            <div className={classes.gridWrap}>
              <GridBox svg={1} />
            </div>
          </div>
        </section>

        <section className={classes.featureSection}>
          <div className={classes.featureText}>
            <p className={classes.eyebrow}>Client-focused delivery</p>
            <h2>Making your goals a reality</h2>
            <p>
              We understand that building work often happens inside people’s
              homes and occupied spaces. That is why we prioritise respectful
              communication, clean worksites and careful coordination from start
              to finish.
            </p>
          </div>
          <div className={classes.featureImage}>
            <img src={fieldImgTwo} alt="Completed remedial building project" />
          </div>
        </section>

        <section className={`${classes.featureSection} ${classes.reverse}`}>
          <div className={classes.featureImage}>
            <img
              src={fieldImgSeven}
              alt="Unified Building Group project site"
            />
          </div>
          <div className={classes.featureText}>
            <p className={classes.eyebrow}>Built on collaboration</p>
            <h2>With you at every step</h2>
            <p>
              We work closely with owners, consultants and stakeholders to keep
              projects moving smoothly. Our approach is practical, transparent
              and focused on the details that protect the long-term result.
            </p>
          </div>
        </section>

        <section className={classes.projectCta}>
          <div className={classes.projectCtaContent}>
            <p className={classes.eyebrow}>Recent work</p>
            <h2>See the quality behind our projects</h2>
            <button
              className={classes.btn}
              onClick={() => navigate("/projects")}
            >
              View Projects
            </button>
          </div>

          <div className={classes.projectCtaImage}>
            <img
              src={fieldImgFiftySeven}
              alt="Unified Building Group project"
            />
          </div>
        </section>

        <section className={classes.statementSection}>
          <div className={classes.statementBox}>
            <span />
            <h2>
              Eliminating the hassle from the way people approach building and
              design.
            </h2>
            <span />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
